import type { NodeProps } from '@xyflow/react';
import { NodeShell } from './nodeShell';

export function EvidenceNode({ data, selected }: NodeProps) {
  const d = data as { title?: string; exhibitRef?: string; summary?: string };
  return (
    <NodeShell title={d.title ?? 'Evidence'} kind="evidence" accent="#a04020" selected={selected}>
      {d.exhibitRef && <div style={{ color: '#555' }}>{d.exhibitRef}</div>}
      {d.summary && <div style={{ marginTop: 2 }}>{d.summary}</div>}
    </NodeShell>
  );
}
